import { getPatternDefForPage } from '@wix/wix-data-client-common/dist/esm/business-logic/dynamic-pages/router-config/routerConfig'
import { truncatePageTitle } from '@wix/wix-data-client-common/dist/esm/business-logic/dynamic-pages/router-config/templates'
import {
  generate as generateRouteDefinition,
  hasPageLinkId,
} from '@wix/wix-data-client-common'
import { generateUniquePrefix } from '../generateUniquePrefix'
import { prefixTitleWithCopyOf, prefixUrlWithCopyOf } from './prefixWithCopyOf'
import { generateUniquePageLinkId } from '../../slug/generatePageLinkId'

const getRouteToDuplicate = async ({ editorSdkProxy, pageRef }) => {
  const routerRef = await editorSdkProxy.document.routers.getByPage({
    pageRef,
  })

  const { config, pages, prefix } = await editorSdkProxy.document.routers.get({
    routerRef,
  })

  const { pattern, def } = getPatternDefForPage(config, pages, pageRef)

  return {
    routeDefinitionBase: def,
    prefix,
    route: pattern,
  }
}

const generatePageTitle = (i18n, originalTitle) => {
  const pageTitle = prefixTitleWithCopyOf(i18n, originalTitle)
  return truncatePageTitle(pageTitle)
}

const generateMenuItemLabel = pageTitle => pageTitle.replace(/ \(All\)$/, '')

export const getDataForNewPage = async ({
  editorSdkProxy,
  i18n,
  pageRef,
  seoV2,
}) => {
  const { prefix, route, routeDefinitionBase } = await getRouteToDuplicate({
    editorSdkProxy,
    pageRef,
  })

  const hadPageLinkId = hasPageLinkId(routeDefinitionBase)
  const inputsForPrefix = [prefixUrlWithCopyOf(prefix)]

  const [routerPrefix, pageData, pageLinkId] = await Promise.all([
    generateUniquePrefix({
      inputsForPrefix,
      editorSdkProxy,
      ignorePageType: true,
    }),
    editorSdkProxy.document.pages.data.get({ pageRef }),
    hadPageLinkId
      ? generateUniquePageLinkId({ editorSdkProxy })
      : Promise.resolve(),
  ])

  const title = pageData.title.trim()

  const pageTitle = generatePageTitle(i18n, title)

  const menuItemLabel = generateMenuItemLabel(pageTitle)

  const routeDefinition = generateRouteDefinition({
    routeDefinitionBase,
    pattern: route,
    collectionId: routeDefinitionBase.config.collection,
    seoV2,
    pageLinkId,
  })

  return {
    route,
    routerPrefix,
    routeDefinition,
    pageTitle,
    menuItemLabel,
    hadPageLinkId,
  }
}
